window.initPastYearsChart = async function (val) {
    if(!val || $(val).is(".initialized")){
        return;
    }

    const isNewDesign = document.querySelector('.etf-fund-page-redesign');
    // prevent rendering the chart in the first place instead of hiding it when there is no series data
    var seriesDataElement = $(val.parentElement).find(".hdnCalendarReturnsChartData");
    var hasSeriesData = false;
    if(seriesDataElement && seriesDataElement.length){
        var seriesData = eval($(seriesDataElement).val());
        for (var i = 0; i < seriesData.length; i++) {
            if(hasSeriesData){
                break;
            }

            for (var j = 0; j < seriesData[i].data.length; j++) {
                if (seriesData[i].data[j] !== null) {
                    hasSeriesData = true;
                    break;
                }
            }
        }
    }

    if(!hasSeriesData){
        return;
    }

    var html = val.ownerDocument.all;
    var descriptionData = "";
    if (html.item("past-years-chart-title") != null) {
        var titleElement = html.item("past-years-chart-title");
        var tickerElement = html.item("past-years-chart-ticker");
        var titleName = titleElement.innerText;
        titleName = "Bar Chart illustrating past performance by " + titleName + ". The x - axis represents time and the y - axis represents percent return.";
        if (tickerElement != null) {
            var tickerName = tickerElement.innerText;
            if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                titleName = "Bar Chart illustrating past performance of " + tickerName + " ETF by Calendar year. The x - axis represents time and the y - axis represents percent return.";
                descriptionData = titleName;
            } else {
                descriptionData = titleName;
            }
        } else {
            descriptionData = titleName;
        }
    }
    var uniqueName = "past-years-chart" + $(".past-years-chart").index(val);
    $(val).attr("id", uniqueName);

    var chartHiddenFields = $(val.parentElement).find('.chart-hidden-fields');
    var sCategories = eval(chartHiddenFields.find('.hdnCalendarReturnsChartCategories').val());
    var masData = eval(chartHiddenFields.find('.hdnCalendarReturnsChartData').val());
    var nodata = chartHiddenFields.find('.hdnCalendarReturnsChartNoData').val();
    var moveToZeroXAxis = eval(chartHiddenFields.find('.hdnMoveToZeroXAxis').val());
    var moveToZeroXAxisLabels = eval(chartHiddenFields.find('.hdnMoveToZeroXAxisLabels').val());
    var xAxisWidth = eval(chartHiddenFields.find('.hdnXAxisWidth').val());

    if (nodata !== '') {
        $('#' + uniqueName).html(nodata);
    } else {
        if (isNewDesign) {
            var fundColors = [
                "#17468F", "#7D868C", "#0AB2BF", "#108A12", "#004402", 
                "#A200b5", "#FF7200", "#FFE100", "#001E6D", "#8CB9E9"
            ];
            
            masData.forEach(function(series, index) {
                var colorIndex = index < fundColors.length ? index : fundColors.length - 1;
                series.color = fundColors[colorIndex];
                series.negativeColor = fundColors[colorIndex];
            });
        }

        var setZeroLineFunc = function () {
            var translated = this.yAxis[0].translate(0, false, false);
            if (isNaN(translated)) {
                return;
            }
            var xx = (-1) * translated;
            if (moveToZeroXAxis) {
                this.xAxis[0].axisGroup.translate(0, xx);
            }
            if (moveToZeroXAxisLabels) {
                this.xAxis[0].labelGroup.translate(0, xx);
            }
        };
        var alterButtonsNotToSendFormFunc = function () {
            $(val).find('button').attr('type', 'button');
        };
        var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                type: 'column',
                marginLeft: 45,
                marginBottom: 130,
                backgroundColor: isNewDesign ? 'transparent' : undefined,
                events: {
                    redraw: setZeroLineFunc,
                    load: setZeroLineFunc,
                    render: alterButtonsNotToSendFormFunc
                }
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: sCategories,
                lineColor: '#000000',
                lineWidth: xAxisWidth
            },
            yAxis: {
                title: {
                    text: ''
                },
                lineColor: '#000000',
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        return this.value + '%';
                    }
                }
            },
            legend: {
                useHTML: true,
                layout: 'vertical',
                align: 'left',
                verticalAlign: 'bottom',
                borderWidth: 0
            },
            tooltip: {
                formatter: function () {
                    return '' +
                        this.series.name + ': ' + this.y + '%';
                }
            },
            credits: {
                enabled: false
            },
            accessibility: {
                description: descriptionData
            },
            series: masData,
            plotOptions: {
                column: {
                    minPointLength: 1
                }
            }
        });
        chart.legend.group.div.setAttribute('data-ve-gtm', 'chart-legend');
        $(val).addClass("initialized");
    }
}
